wbApp.controller('ProtectedStorageSelectDlgCtrl', ['$scope', '$timeout', '$modal', '$translate', 'protectedStorageSvc',
function ($scope, $timeout, $modal, $translate, protectedStorageSvc) {

    $scope.onOk = function () {

        if (!!$scope.onFilesSelected) {
            if (!!fileManagerInstance) {
                var selectedItems = fileManagerInstance.getSelectedItems();
                selectedItems = _.filter(selectedItems, { isDirectory: !!$scope.selectFoldersOnly });


                var selectedFiles = _.map(selectedItems, function (value, index, collection) {
                    return {
                        objectUri: value.key,
                        name: value.name,
                        contentType: value.dataItem.contentType,
                    };
                });

                $scope.onFilesSelected(selectedFiles);
            }            
        }

        $scope.$hide();
    }

    $scope.isNothingSelected = function () {
        if (!!fileManagerInstance) {
            var selectedItems = fileManagerInstance.getSelectedItems();
            selectedItems = _.filter(selectedItems, { isDirectory: !!$scope.selectFoldersOnly });
            return selectedItems == null || selectedItems.length == 0;
        } else {
            return true;
        }
    }

    var fileManagerInstance;
    $scope.fileManagerOptions = {
        fileSystemProvider: new DevExpress.fileManagement.CustomFileSystemProvider({
            getItems: function (pathInfo) {
                return protectedStorageSvc.getDirectory(pathInfo.path).$promise;
            },
            contentExpr: "contentType",
            dateModifiedExpr: "createdAtUtc",
        }),
        selectionMode: "multiple",       
        onContentReady: function (e) {
            fileManagerInstance = e.component;
        },
        onSelectionChanged: function (e) {

            if (!!$scope.selectFoldersOnly) {
                var selectedItems = fileManagerInstance.getSelectedItems();

                var selectedFiles = _.filter(selectedItems, { isDirectory: false });

                if (selectedFiles != null && selectedFiles.length > 0) {
                    var selectedItemKeys = _.map(_.filter(selectedItems, { isDirectory: true }), 'key');
                    fileManagerInstance.option("selectedItemKeys", selectedItemKeys);
                }
            }
        }
    }
}]);
